export default __webpack_public_path__ + "static/media/Nosotros_imagen2_1152.f228067c.jpg";